<template>
  <div class="articleInfoPage">
    <headerCom :headerBlue="headerBlue" ref="headerComDom"></headerCom>
    <div class="main-container">
      <!-- 页面路径--->
      <div class="main-content">
        <div class="main-crumb-container">
          <div class="main-crumb-content">
            <div class="main-crumb-txt" @click="toHome($event)">首页</div>
            <img class="main-crumb-icon" src="../assets/navbar_right arrow.png">
            <div class="main-crumb-txt" @click="toArticle(0,$event)">动态</div>
            <img class="main-crumb-icon" src="../assets/navbar_right arrow.png">
            <div class="main-crumb-txt">{{title}}</div>
            <div class="clearboth"></div>
          </div>
        </div>
      </div>
      <!--文章内容 -->
      <div class="main-content">
        <div class="main-article-info-container">
          <div class="main-article-info">
            <div class="main-article-info-title">{{title}}</div>
            <div class="main-article-info-tag-container">
              <div class="main-article-info-tag">薪领航管理咨询有限公司</div>
              <div class="main-article-info-tag">浏览数：{{readQuantitie}}</div>
              <div class="main-article-info-tag">创作人：{{createdUserName}}</div>
              <div class="main-article-info-tag">发布时间：{{dateFormatTime(lawDate)}}</div>
              <div class="clearboth"></div>
            </div>
            <div class="main-article-info-content" v-html="content"></div>
          </div>
          <div class="main-article-info-line"></div>
        </div>
        <div class="main-article-info-relate-container">
          <div class="main-article-info-relate-title">相关标签</div>
          <div class="main-article-info-relate-category-container">
            <div class="main-article-info-relate-category" v-for="v in relateCategory" @click="toArticle(v.id,$event)">{{v.name}}</div>
            <div class="clearboth"></div>
          </div>
        </div>
        <div class="clearboth"></div>
      </div>

      <!-- 相关动态 -->
      <div class="main-content">
        <div class="main-content-title-container">
          <div class="main-content-title">相关动态</div>
          <div class="clearboth"></div>
        </div>

        <div class="main-article-container" v-for="(v,index) in relateHrData.slice(0,3)">
          <div class="main-article" @click="toArticleInfo(v.id,$event)">
            <div class="main-article-media-container">
              <img class="main-article-media-file" :src="v.articleSrc">
            </div>
            <div class="main-article-content">
                <div class="main-article-category-container">
                  <div class="main-article-category" v-for="vc in v.categoryData">{{vc.name}}</div>
                  <div class="clearboth"></div>
                </div>
                <div class="main-article-title">{{v.title}}</div>
                <div class="main-article-preview">{{v.content}}</div>
                <div class="main-article-browse">浏览数&nbsp;{{v.readQuantitie}}</div>
            </div>
            <div class="clearboth"></div>
          </div>
          <div class="main-article-split-line" v-if="index<relateHrData.length-1"></div>
        </div>
        <div class="main-article-more-container">
          <div class="main-article-more" @click="toArticle(0,$event)">
            查看更多动态
            <img class="main-icon-more" src="../assets/icon_more.png" />
          </div>
        </div>
      </div>
    </div>


    <foot></foot>
  </div>
</template>

<script>
import headerCom from "@/components/Header.vue";
import foot from "@/components/Footer.vue";
import axios from "axios";

export default {
  data() {
    return {
      headerBlue: true, //表头变蓝
      id: 0,
      title: "",
      readQuantitie: 0,
      createdUserName: "",
      lawDate: "",
      content: "",
      relateHrData: [],
      relateCategory: [],

      articleSrc1: require("../assets/article_list_img.png"),
      articleSrc2: require("../assets/article_list_img_2.png"),
      articleSrc3: require("../assets/article_list_img_3.png"),
      articleSrc4: require("../assets/article_list_img_4.png"),
      articleSrc5: require("../assets/article_list_img_5.png"),
      articleSrc6: require("../assets/article_list_img_6.png"),
    };
  },
  components: {
    headerCom,
    foot,
  },
  created() {
    document.documentElement.scrollTop = 0;
    //this.id = this.$route.params.id
    this.id = this.$route.query.id
    let params = {};
    params.id = this.id;
    axios
      .get("pilotage/articleById", {params: params})
      .then((res) => {
        if(res!=null && res.data!=null){
          if(res.data.hrData!=null){
            this.title = res.data.hrData.title
			document.title = this.title + '_薪领航管理咨询有限公司';
            if(res.data.hrData.readQuantitie!=null){
              this.readQuantitie = res.data.hrData.readQuantitie
            }
            this.createdUserName = res.data.hrData.createdUserName
            if(res.data.hrData.lawDate!=null){
              this.lawDate = res.data.hrData.lawDate
            }else{
              this.lawDate = res.data.hrData.createdDatetime
            }
            this.content = res.data.hrData.content
          }
          if(res.data.relateCategory!=null){
            for(let i=0;i<res.data.relateCategory.length;i++){
              this.relateCategory.push({id: res.data.relateCategory[i].lawLabelId, name: res.data.relateCategory[i].lawLabelName})
            }
          }
          if(res.data.relateHrData!=null){
            for(let j=0;j<res.data.relateHrData.length;j++){
              let id = res.data.relateHrData[j].id
              let title = res.data.relateHrData[j].title
              let content = res.data.relateHrData[j].content
              let readQuantitie = 0
              if(res.data.relateHrData[j].readQuantitie!=null){
                readQuantitie = res.data.relateHrData[j].readQuantitie
              }

              let articleSrc = "";
              if(res.data.relateHrData[j].videoPosterPath!=null){
                articleSrc = res.data.relateHrData[j].videoPosterPath
              }else if(res.data.relateHrData[j].imgSrc!=null){
                articleSrc = res.data.relateHrData[j].imgSrc
              }else{
                if(id%6==0){
                  articleSrc = this.articleSrc1
                }else if(id%6==1){
                  articleSrc = this.articleSrc2
                }else if(id%6==2){
                  articleSrc = this.articleSrc3
                }else if(id%6==3){
                  articleSrc = this.articleSrc4
                }else if(id%6==4){
                  articleSrc = this.articleSrc5
                }else if(id%6==5){
                  articleSrc = this.articleSrc6
                }
              }

              //文章标签
              let categoryData = []
              if(res.data.relateHrData[j].articleLabelList!=null){
                for(let k=0;k<res.data.relateHrData[j].articleLabelList.length;k++){
                  let categoryId = res.data.relateHrData[j].articleLabelList[k].lawLabelId
                  let categoryName = res.data.relateHrData[j].articleLabelList[k].lawLabelName
                  categoryData.push({id:categoryId,name:categoryName})
                }
              }

              this.relateHrData.push({id:id,title:title,content:content,readQuantitie:readQuantitie,categoryData:categoryData,articleSrc:articleSrc})
            }
          }

        }
      })
      .catch((res) => {});
  },
  mounted() {
    document.addEventListener("click", (e) => {
      let scrollTop = document.documentElement.scrollTop;
      let x = e.x;
      let y = Math.floor(e.y + scrollTop);
      this.$refs.headerComDom.toVisitPage(this.$route.path,this.$route.path,0,0,x,y);
    });

  },
  methods: {
    //格式化日期 xx年xx月xx日
    dateFormatTime(time) {
      var date = new Date(time);
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var day = date.getDate();

      return year + "年" + month + "月" + day + "日";
    },
    //跳转动态详情页
    toArticleInfo(id,e){
      let scrollTop = document.documentElement.scrollTop;
      let x = e.x;
      let y = Math.floor(e.y + scrollTop);
      this.$refs.headerComDom.toVisitPage(this.$route.path,'/articleInfo',0,id,x,y);
      this.id = id
      let params = {};
      params.id = this.id;
      axios
        .get("pilotage/articleById", {params: params})
        .then((res) => {
          if(res!=null && res.data!=null){
            this.relateHrData = []
            this.relateCategory = []
            if(res.data.hrData!=null){
              this.title = res.data.hrData.title
              this.readQuantitie = res.data.hrData.readQuantitie
              this.createdUserName = res.data.hrData.createdUserName
              if(res.data.hrData.lawDate!=null){
                this.lawDate = res.data.hrData.lawDate
              }else{
                this.lawDate = res.data.hrData.createdDatetime
              }

              this.content = res.data.hrData.content
            }
            if(res.data.relateCategory!=null){
              for(let i=0;i<res.data.relateCategory.length;i++){
                this.relateCategory.push({id: res.data.relateCategory[i].lawLabelId, name: res.data.relateCategory[i].lawLabelName})
              }
            }
            if(res.data.relateHrData!=null){
              for(let j=0;j<res.data.relateHrData.length;j++){
                let id = res.data.relateHrData[j].id
                let title = res.data.relateHrData[j].title
                let content = res.data.relateHrData[j].content
                let readQuantitie = 0
                if(res.data.relateHrData[j].readQuantitie!=null){
                  readQuantitie = res.data.relateHrData[j].readQuantitie
                }

                let articleSrc = "";
                if(res.data.relateHrData[j].videoPosterPath!=null){
                  articleSrc = res.data.relateHrData[j].videoPosterPath
                }else if(res.data.relateHrData[j].imgSrc!=null){
                  articleSrc = res.data.relateHrData[j].imgSrc
                }else{
                  if(id%6==0){
                    articleSrc = this.articleSrc1
                  }else if(id%6==1){
                    articleSrc = this.articleSrc2
                  }else if(id%6==2){
                    articleSrc = this.articleSrc3
                  }else if(id%6==3){
                    articleSrc = this.articleSrc4
                  }else if(id%6==4){
                    articleSrc = this.articleSrc5
                  }else if(id%6==5){
                    articleSrc = this.articleSrc6
                  }
                }

                //文章标签
                let categoryData = []
                if(res.data.relateHrData[j].articleLabelList!=null){
                  for(let k=0;k<res.data.relateHrData[j].articleLabelList.length;k++){
                    let categoryId = res.data.relateHrData[j].articleLabelList[k].lawLabelId
                    let categoryName = res.data.relateHrData[j].articleLabelList[k].lawLabelName
                    categoryData.push({id:categoryId,name:categoryName})
                  }
                }

                this.relateHrData.push({id:id,title:title,content:content,readQuantitie:readQuantitie,categoryData:categoryData,articleSrc:articleSrc})
              }
            }

            document.documentElement.scrollTop = 0;
          }
        })
        .catch((res) => {});
    },
    //相关标签跳转动态页
    toArticle(lawLabelId,e){//0全部标签
      let scrollTop = document.documentElement.scrollTop;
      let x = e.x;
      let y = Math.floor(e.y + scrollTop);
      this.$refs.headerComDom.toVisitPage(this.$route.path,'/article',0,0,x,y);
      this.$router.push({name:'article',params:{lawLabelId:lawLabelId}});
    },
    //跳转首页
    toHome(e){
      let scrollTop = document.documentElement.scrollTop;
      let x = e.x;
      let y = Math.floor(e.y + scrollTop);
      this.$refs.headerComDom.toVisitPage(this.$route.path,'/',0,0,x,y);
      this.$router.push('/');
    },
  },
};
</script>

<style>
  .articleInfoPage .main-content:first-child{
    padding-top: 0;
  }
  .main-article-info-container{
    float: left;
    margin: 0 0 0 180px;
    width: calc(67% - 180px);
    position: relative;
  }
  .main-article-info{
    float: left;
    width: calc(100% - 40px);
  }
  .main-article-info-line{
    position: absolute;
    height: calc(100% - 2px);
    top: 2px;
    right: 0;
    background: #E7EEF9;
    width: 1px;
  }
  .main-article-info-title{
    font-weight: 500;
    font-size: 36px;
    line-height: 38px;
    color: #333333;
  }
  .main-article-info-tag-container{
    margin: 20px 0 0 0;
  }
  .main-article-info-tag{
    font-size: 16px;
    line-height: 28px;
    color: #4F617E;
    margin: 0 0 0 20px;
    float: left;
  }
  .main-article-info-tag:first-child{
    margin-left: 0;
  }
  .main-article-info-content{
    margin: 50px 0 0 0;
  }
  .main-article-info-relate-container{
    float: left;
    width: calc(33% - 210px);
    margin: 0 0 0 30px;
  }
  .main-article-info-relate-title{
    font-weight: 500;
    font-size: 18px;
    line-height: 28px;
    color: #333333;
  }
  .main-article-info-relate-category-container {
    margin: 16px 0 0 0;
  }
  .main-article-info-relate-category{
    padding: 4px 10px;
    font-size: 12px;
    line-height: 16px;
    color: #1055C1;
    background: #E7EEF9;
    border-radius: 4px;
    cursor: pointer;
    float: left;
    margin: 0 0 0 8px;
  }
  .main-article-info-relate-category:first-child{
    margin-left: 0px;
  }

  .articleInfoPage .main-content-title{
    background: url("../assets/Line5.png") no-repeat;
    background-size: 100% 5px;
    background-position: 0% 60%;
  }

  .articleInfoPage .main-content .main-article-container:nth-child(2){
    margin-top: 50px;
  }

</style>



// WEBPACK FOOTER //
// src/pages/articleInfo.vue